import oIconLibrary from 'utils/iconLibrary';

// This function is in its own file instead of `./helpers.js` because
// Jest can't deal with the Redux store and Redux action imports in the helpers file.

type VolunteerType = {
  NAME: string;
};

/**
 * Builds navigation options based on user roles, constituencies, and other conditions.
 *
 * @param {Array<Object>} volunteerTypes - List of volunteer types associated with the user.
 * @param {Array<string>} userConstituencies - List of constituencies the user belongs to.
 * @param {boolean} isScholarshipRecipient - Indicates if the user is a scholarship recipient.
 * @returns {Array<Object>} Array of navigation option objects, each containing label, path, and icon.
 */
const fnBuildNavOptions = (
  volunteerTypes: Array<VolunteerType> = [],
  userConstituencies = [],
  isScholarshipRecipient = false
) => {
  const navOptions = [
    { label: 'Home', path: '/main', icon: oIconLibrary.fontAwesome.home },
    {
      label: 'Philanthropy',
      path: '/philanthropy',
      icon: oIconLibrary.fontAwesome.handsHoldingHeart,
    },
  ];

  if (isScholarshipRecipient) {
    navOptions.push({
      label: 'Scholarships',
      path: '/scholarships',
      icon: oIconLibrary.fontAwesome.graduationCap,
    });
  }

  const isReunionVolunteer = volunteerTypes.some(
    (type) => type.NAME === 'Reunion Volunteer'
  );
  if (isReunionVolunteer) {
    navOptions.push({
      label: 'Volunteers',
      path: '/volunteers',
      icon: oIconLibrary.fontAwesome.users,
    });
  }

  navOptions.push({
    label: 'Profile Settings',
    path: '/profile-settings',
    icon: oIconLibrary.fontAwesome.gear,
  });

  const constituenciesAllowedToMakeAlumGmail = [
    'Alumnus',
    'Non-degreed Alumna/us',
    'Student',
    'Withdrawn Student',
  ];
  const isAllowedToMakeAlumGmail = userConstituencies.some((constituency) =>
    constituenciesAllowedToMakeAlumGmail.includes(constituency)
  );

  if (isAllowedToMakeAlumGmail) {
    navOptions.push({
      label: 'Settings',
      path: '/settings',
      icon: oIconLibrary.fontAwesome.gear,
    });
  }

  return navOptions;
};

export default fnBuildNavOptions;
